import React from 'react'
import "./color.css"

function OrangeP() {
    var x = localStorage.getItem("percentage protein")

    return (
        <div className = "orange__background">
            {x == "NaN" ? "null": x} %
        </div>
    )
}

export default OrangeP
